var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-input',{staticStyle:{"font-size":"16px","width":"100px"},attrs:{"disabled":_vm.showEventData?.type !== 'not_sended',"value":_vm.$props.defaultRate},on:{"change":event => _vm.changeRate(event)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }